export { default as ToggleGroupControlOptionIcon } from './component';